module.exports = __webpack_public_path__ + "static/media/logo.4a87cc37.jpg";